import { ReactNode } from 'react'
import {
  Box,
  Flex,
  Heading,
  List,
  ListItem,
  ListIcon,
  Image,
  useBreakpointValue,
  HStack,
  VStack
} from '@chakra-ui/react'
import AuthIllustration from 'assets/images/auth-illustration.png'
import useBreakPoint from 'hooks/useBreakPoint'
import { EBreakPoint } from 'constants/theme'

interface AuthLayoutProps {
  children: ReactNode
  title?: string
  features?: string[]
}

const AuthLayout = ({
  children,
  title = 'Welcome to HowFactory',
  features = ['All you need in one single platform', 'Fast and easy to use', 'No credit card commitment']
}: AuthLayoutProps) => {
  const isMobile = useBreakPoint(EBreakPoint.LG)
  const showWelcomeSection = isMobile

  return (
    <Flex minH="100vh" w="100vw">
      {showWelcomeSection && (
        <Box
          w="500px"
          h="100vh"
          bgGradient="linear(198.36deg, #F0F3FF 0%, #C4ECFF 100%)"
          display="flex"
          alignItems="center"
          justifyContent="center"
          position="relative"
          flexShrink={0}
          style={{
            minWidth: '500px',
            maxWidth: '500px',
            transform: 'translateZ(0)',
            willChange: 'transform'
          }}
        >
          <VStack w="100%" align="flex-start" h="100vh" justify="flex-end" position="relative">
            <VStack justify="center" w="80%" pb={12}>
              <Heading as="h1" fontSize="24px" fontWeight="600" mb={6} color="#2D3748" lineHeight="32px" margin={0}>
                {title}
              </Heading>

              <List ml={6} padding={0} listStyleType="disc">
                {features.map((feature, index) => (
                  <ListItem key={index} fontSize="16px" color="#4A5568" fontWeight="400">
                    {feature}
                  </ListItem>
                ))}
              </List>
            </VStack>
            <Image
              src={AuthIllustration}
              alt="HowFactory Platform Illustration"
              bottom={0}
              left={0}
              h="435px"
              objectFit="contain"
              opacity="85%"
              borderTopRightRadius="24px"
            />
          </VStack>
        </Box>
      )}

      {/* Right Section - Form Content */}
      <Flex
        flex={1}
        align="center"
        justify="center"
        bg="white"
        minH={{ base: '100vh', lg: 'auto' }}
        style={{
          minWidth: '0',
          flex: '1 1 auto'
        }}
      >
        {children}
      </Flex>
    </Flex>
  )
}

export default AuthLayout
